import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isAutoLogin: false,
        isproblem: '',//常见问题
        isloading: false,
        ishongdian: false,
        isinvitation: true,
        isLogin: false,
        isRegister: false,
        loginStatus: false,
        name: '',
        mobile: '',
        company: '',
        unauthorized: null,
        isOpenUp: false,    //是否显示企业为开通弹窗
        kindTab:'trade',     //注册弹窗的tab

        hasCompanyId:true
    },
    mutations: {
        Logintrue(state) {
            state.isAutoLogin = true;
        },
        Loginfalse(state) {
            state.isAutoLogin = false;
        },
        problemfalse(state) {
            state.isproblem = false;
        },
        problemtrue(state) {
            state.isproblem = true;
        },
        clicklogintrue(state) {
            state.isLogin = true;
        },
        clickloginfalse(state) {
            state.isLogin = false;
        },
        clickregistertrue(state) {
            state.isRegister = true;
        },
        clickregisterfalse(state) {
            state.isRegister = false;
        },

        setLoginStatustrue(state) {
            state.loginStatus = true;
        },
        setLoginStatusfalse(state) {
            state.loginStatus = false;
        },

        setname(state, name) {
            state.name = name;
        },
        setmobile(state, mobile) {
            state.mobile = mobile;
        },
        setcompany(state, company) {
            state.company = company;
        },

        setOpenUpshow(state, unauthorized) {
            state.isOpenUp = true;
            state.unauthorized = unauthorized;
        },
        setOpenUphide(state) {
            state.isOpenUp = false;
        },

        setKindTab(state,kind){
            state.kindTab = kind;
        },

        setCompanyIdHas(state) {
            state.hasCompanyId = true;
        },
        setCompanyIdNone(state) {
            state.hasCompanyId = false;
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js